// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7ba663c","marketsWrapper":"_aa9d9a5"};